module.exports = __webpack_public_path__ + "static/media/house-and-garden-white.4145464f.svg";